import React from 'react';
import { cn } from './cn';

function Separator({ className, orientation = 'horizontal', ...props }) {
  return (
    <div
      role="separator"
      aria-orientation={orientation}
      className={cn('ui-separator', orientation === 'vertical' && 'ui-separator--vertical', className)}
      {...props}
    />
  );
}

export { Separator };
